import { useEffect } from 'react'
import { Flex } from '@chakra-ui/react'

import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function AtualizacaoDeDadosCadastraisSaudeIndigena() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch } = formMethods

  const tagForQuestion = Object.fromEntries(questions.flatMap((q) => q.tags.map((tag: string) => [tag, q.slug])))

  const cargo = watch ? watch(`form_answers.${tagForQuestion['cargo']}`) : undefined

  const possui_registro_no_conselho_de_classe = watch
    ? watch(`form_answers.${tagForQuestion['possui_registro_no_conselho_de_classe']}`)
    : undefined

  const possui_deficiencia = watch ? watch(`form_answers.${tagForQuestion['possui_deficiencia']}`) : undefined

  const estrangeiro = watch ? watch(`form_answers.${tagForQuestion['estrangeiro']}`) : undefined

  useEffect(() => {
    const cargosComConselho = [
      'APOIADOR TECNICO DE SANEAMENTO',
      'ARQUITETO E URBANISTA',
      'ASSISTENTE SOCIAL',
      'BIOLOGO',
      'CIRURGIAO DENTISTA',
      'ENFERMEIRO',
      'ENGENHEIRO CIVIL',
      'ENGENHEIRO ELETRICISTA',
      'ENGENHEIRO SANITARISTA',
      'FARMACEUTICO',
      'FISIOTERAPEUTA',
      'GEOLOGO',
      'MEDICO',
      'MEDICO VETERINARIO',
      'NUTRICIONISTA',
      'PEDAGOGO',
      'QUIMICO',
      'TERAPEUTA OCUPACIONAL',
      'AUXILIAR DE SAUDE BUCAL',
      'TECNICO EM EDIFICAÇÕES',
      'TECNICO DE ENFERMAGEM',
      'TECNICO DE LABORATORIO',
      'TECNICO EM SAUDE BUCAL',
      'TECNICO EM ELETROTECNICO',
      'TECNICO EM SANEAMENTO E CONTROLE AMBIENTAL',
      'TECNICO EM NUTRIÇAO DIETETICA',
    ]

    if (cargo) {
      if (cargosComConselho.includes(cargo)) {
        formMethods.setValue(`form_answers.${tagForQuestion['possui_registro_no_conselho_de_classe']}`, 'Sim')
      } else {
        formMethods.setValue(`form_answers.${tagForQuestion['possui_registro_no_conselho_de_classe']}`, 'Não')
      }
    }
  }, [cargo])

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        //REGISTRO
        if (question.tags.includes('numero_do_registro') || question.tags.includes('envio_registro_de_classe')) {
          if (possui_registro_no_conselho_de_classe === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        //deficiencia
        if (question.tags.includes('tipo_deficiencia') || question.tags.includes('laudo_deficiencia')) {
          if (possui_deficiencia === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        //estrangeiro
        if (question.tags.includes('estrangeiro_visto')) {
          if (estrangeiro === 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={question}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
